import React, { useState } from 'react';
import logo from './logo.svg';
import './App.scss';
import Header from './Header';
import Project from './Project';

function App() {

  const [activeLink, setActiveLink] = useState('');

  return (
    <div className="app">      
      <Header />
      <div className="content">
        <section className="intro">
          <div className="sectionInner">
            <div className="imgContainer">
              <img src="./media/profile-pic.png"/>
            </div>
            <div className="copy">
              <p className="title">Web developer, interdisciplinary creator.</p>
              <div className="body">
                <p>I’m a <strong>full stack web developer</strong> with an entrepreneurial spirit and a love for ambitious, values-driven work.</p>
                <p>My passions lie at the intersection of community-building, entrepreneurship, literature, interactivity, and technology.</p>
              </div>
            </div>
          </div>
        </section>
        <section id="overview" className="overview">
          <h2>Overview</h2>
          <div className="sectionInner">
            <div className="copy">
              <h3>8 years of development <br /> and startup experience</h3>
            </div>
            <div className="copy">
              <h3>Things I've programmed</h3>
              <p>• News and learning platforms (IBM)</p>
              <p>• Digital books and game</p>
              <p>• Analytics dashboards</p>
              <p>• Enterprise e-commerce websites</p>
            </div>
            <div className="copy">
              <h3>Additional skills</h3>
              <p>• Market research</p>
              <p>• Strategic analysis</p>
              <p>• Agile (SCRUM)</p>
              <p>• UX and UI design</p>
              <p>• Management</p>
            </div>
            <a className="buttonLink" href="./media/artemio-morales-resume.pdf"  download="Artemio's Resume">
              <div className="button">Download Full Resume</div>
            </a>
          </div>
        </section>
        <section id="startupWork" className="standardGroup">
          <h2>Startup Work</h2>
          <div className="sectionInner">
            <Project title={"AltSalt.com"} subheading={"Community Website"} imgURL={"./media/altsalt-website-screenshot.png"} activeLink={activeLink} setActiveLink={setActiveLink}>
                <p>A community website for promoting underrepresented voices in publishing. I began conducting research interviews in March 2020, designed the site, assembled a team of volunteers, and am now approaching a beta release.</p>
                <p>Technologies: React (Next.js), Python (Django), GraphQL (Graphene), Heroku</p>
                <p><a href="https://altsalt-frontend-ten.vercel.app" target="_blank">Visit Live Prototype</a></p>
            </Project>
            <Project title={"Maestro"} subheading={"Unity3D Editor Extension"} imgURL={"./media/maestro-screenshot.png"} activeLink={activeLink} setActiveLink={setActiveLink}>
                <p>A Unity3D editor extension for creating responsive animated books. Built in part on Unity’s Timeline tool, Maestro is a suite of modules for orchestrating complex animated sequences, localizing detailed typographic designs, and adapting layouts responsively across devices.</p>
                <p>Technologies: Unity3D</p>
                <p><a href="https://youtu.be/FfUJ8mlvf9c" target="_blank">View Development Demos</a></p>
            </Project>
            <Project title={"A Modern Ghost"} subheading={"Multimedia Book for iOS and Android"} imgURL={"./media/a-modern-ghost-01.png"} activeLink={activeLink} setActiveLink={setActiveLink}>
                <p>A prototype multimedia short story, I produced the project and did the overall direction, as well as the artwork and programming. I also collaborated on the design with two others.</p>
                <p>Technologies: Unity3D</p>
                <p><a href="https://apps.apple.com/us/app/a-modern-ghost/id1184166872" target="_blnak">iOS App Store</a> | <a href="https://play.google.com/store/apps/details?id=com.altsalt.modernghost&hl=en_US" target="_blank">Google Play</a></p>
            </Project>
          </div>
        </section>
        <section id="employment" className="standardGroup">
          <h2>Employment and Contract Work</h2>
          <div className="sectionInner">
            <Project title={"IBM Internal Projects"} subheading={"Discovery, Learning, and News Platforms"} imgURL={"./media/ibm-bus.png"} activeLink={activeLink} setActiveLink={setActiveLink}>
                <p>While working at the agency VSA Partners, I helped develop and maintain the front end for internal platforms at IBM, including their company directory, an employee educational platform, and an internal news platform.</p>
                <p>Technologies: React, Drupal, C3, JavaScript, HTML, CSS</p>
            </Project>
            <Project title={"Green Our Home"} subheading={"Digital Children's Book"} imgURL={"./media/green-our-home.jpg"} activeLink={activeLink} setActiveLink={setActiveLink}>
                <p>A fun interactive story that teaches children about recycling. I programmed, deployed, and continue to maintain this ebook for iOS and Android.</p>
                <p>Technologies: Unity3D</p>
                <p><a href="https://apps.apple.com/us/app/green-rank-green-our-home/id1420305664" target="_blnak">iOS App Store</a> | <a href="https://play.google.com/store/apps/details?id=me.greenrank.greenourhome&hl=en_US" target="_blank">Google Play</a></p>
            </Project>
            <Project title={"Living Proof"} subheading={"Enterprise E-Commerce Website"} imgURL={"./media/living-proof.png"} activeLink={activeLink} setActiveLink={setActiveLink}>
                <p>While working as a front end developer at Pixafy, I helped develop and maintain enterprise e-commerce websites. Tasks included implementing coupon codes, revising checkout experiences, updating styles, and more.</p>
                <p>Technologies: HTML, JavaScript, SASS, PHP (Magento)</p>
            </Project>
          </div>
        </section>
        <section id="gameJams" className="standardGroup">
          <h2>Game Jams</h2>
          <div className="sectionInner">
            <Project title={"Stitch Me"} subheading={"Magical Teddy Bear Hospital"} imgURL={"./media/stitchme-1.png"} activeLink={activeLink} setActiveLink={setActiveLink}>
                  <p>With tender love and care, repair your damaged plush friends. One of the main programmers, I created this with a team of 5 for NYC Global Game Jam 2020.</p>
                  <p>Technologies: Unity3D</p>
                  <p><a href="https://jonmorales.itch.io/stitch-me" target="_blank">Play on iOS, Android, or Browser</a></p>
            </Project>
            <Project title={"Rooombra Rescue!"} subheading={"A Vacuum Saves the World"} imgURL={"./media/rooombra.png"} activeLink={activeLink} setActiveLink={setActiveLink}>
                  <p>Inspired by stories of abandoned ships like the St. Mary Celeste,  you play as GWR 3000, an autonomous Rooombra vacuum cleaner. I implemented gameplay and the final RPG sequence. Completed with a team of 3 for Isolation Jam 2020.</p>
                  <p>Technologies: Unity3D</p>
                  <p><a href="https://artemiosans.itch.io/rooombra-to-the-rescue" target="_blank">Download for Mac or Windows</a></p>
            </Project>
          </div>
        </section>
        <section id="contact" className="standardGroup contact">
          <h2>Contact</h2>
          <h3>Email</h3>
          <p>artemio [at] altsalt.com</p>
          <h3>Instagram</h3>
          <p><a href="https://www.instagram.com/artemiosans/">@artemiosans</a></p>
        </section>
      </div>

    </div>
  );
}

export default App;
